/// <reference path="../modules/app.module.ts" />
/// <reference path="../objects/interfaces/istoredate.ts" />

module App.Services {
    export interface IDataService {
        getFirstStoreDates(storeIds: number[], selectProductNames: string[], waitForJob: boolean): ng.IPromise<App.Interfaces.IStoreDate[]>;
    }

    export class DataService implements IDataService {
        static serviceId = 'dataService';

        static $inject = [
            '$state',
            '$q',
            App.HttpHelper.factoryId
        ];

        constructor(private $state: ng.ui.IStateService,
            private $q: ng.IQService,
            private httpHelper: IHttpHelper,) {

        }

        getFirstStoreDates = (storeIds: number[], selectProductNames: string[], waitForJob: boolean): ng.IPromise<App.Interfaces.IStoreDate[]> => {
            var deffered = this.$q.defer<App.Interfaces.IStoreDate[]>();

            var method = 'POST';
            this.httpHelper.makeCall<App.Interfaces.IStoreDate[]>(Constants.websiteUrlCalls.storeFirstDateRequest, method, { storeIds: storeIds, selectedProducts: selectProductNames, waitForJob: waitForJob }, { 'AmegaPlannerFranchise': App.Variables.websiteId }).then(
                (result) => {
                    if (result != null)
                        deffered.resolve(result);
                    else
                        deffered.reject('no address');
                }).catch((err) => {
                    deffered.reject(err.message);
            });

            return deffered.promise;
        }
    }

    app.service(DataService.serviceId, DataService);
}